import { HealthPlanFieldState } from '@/modules/HealthPlan/HealthPlan.types';
import { ErrorsField } from '@/utils/store/baseStoreCreator';
import { storeCreator } from '@/utils/store/store.utils';

export interface CoverageLevelsFieldsStatePayload {
  id?: string;
  coverageId: string;
  coverageCode?: HealthPlanFieldState;
  planDeductible?: HealthPlanFieldState;
  memberDeductible?: HealthPlanFieldState;
  embeddedAmount?: HealthPlanFieldState;
}

export const DEFAULT_VALUES: CoverageLevelsFieldsStatePayload = {
  id: '',
  coverageId: '',
  coverageCode: HealthPlanFieldState.Modifiable,
  planDeductible: HealthPlanFieldState.Modifiable,
  memberDeductible: HealthPlanFieldState.Modifiable,
  embeddedAmount: HealthPlanFieldState.Modifiable,
};

interface FieldsStateStoreState {
  state: CoverageLevelsFieldsStatePayload[];
  sourceState: CoverageLevelsFieldsStatePayload[];
  errors: Partial<CoverageLevelsFieldsStatePayload[]>;
  errorFields: Partial<ErrorsField<CoverageLevelsFieldsStatePayload[]>>;
  showErrors: boolean;

  setState: (values: CoverageLevelsFieldsStatePayload[]) => void;
  setSourceState: (values: CoverageLevelsFieldsStatePayload[]) => void;
  setShowErrors: (value: boolean) => void;
  setErrors: (values: Partial<CoverageLevelsFieldsStatePayload[]>) => void;
  setErrorFields: (values: Partial<ErrorsField<CoverageLevelsFieldsStatePayload[]>>) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<FieldsStateStoreState>((set) => ({
  state: [],
  sourceState: [],
  errors: [],
  errorFields: [],
  showErrors: false,

  handleReset: () =>
    set(() => ({
      state: [],
      sourceState: [],
      errors: [],
      errorFields: [],
      showErrors: false,
    })),
  setShowErrors: (value) => set(() => ({ showErrors: value })),
  setErrors: (values) => set(() => ({ errors: values })),
  setErrorFields: (values) => set(() => ({ errorFields: values })),
  setState: (values) => set(() => ({ state: values })),
  setSourceState: (values) => set(() => ({ sourceState: values })),
}));

export default useStore;
